import React, { useState } from 'react';
import { Button, useListContext, useNotify, useUnselectAll, useDataProvider, useRefresh } from 'react-admin';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Delete } from '@mui/icons-material';
import MyLoading from '../components/MyLoading';
import { useTranslate  } from '../common/language';


const BulkDeleteButton = ({ resource_name, confirmTitle, confirmDescription, confirmAsk, minRemaining = 0, minRemainingError, ...props}) => {
    const { selectedIds, ids = [], total } = useListContext();
    const [open, setOpen] = useState(false);
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const refresh = useRefresh();
    const [loading, setLoading] = useState(false);
    const translate = useTranslate(); 

    const getTotalItems = () => typeof total === 'number' ? total : ids.length;

    const selectionWouldDeleteTooMany = () => {
        const totalItems = getTotalItems();
        return minRemaining > 0 && totalItems > 0 && selectedIds.length > totalItems - minRemaining;
    };

    const notifyMinRemainingError = () => {
        notify(minRemainingError || 'No es poden esborrar tots els registres.', 'error');
    };

    const handleClickOpen = () => {
        if (selectionWouldDeleteTooMany()) {
            notifyMinRemainingError();
            return;
        }

        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = async () => {
        if (selectionWouldDeleteTooMany()) {
            notifyMinRemainingError();
            handleClose();
            return;
        }

        setLoading(true);

        const results = [];
        for (const id of selectedIds) {
            try {
                await dataProvider.delete(resource_name, { id });
                results.push({ status: 'fulfilled' });
            } catch (error) {
                results.push({ status: 'rejected', reason: error });
            }
        }

        const errors = results
            .filter(result => result.status === 'rejected')
            .map((result, index) => ({
                id: selectedIds[index],
                message: result.reason.message,
            }));

        if (errors.length > 0) {
            notify(translate('users.delete_all_ko') + ` ${errors.map(e => '\n' + e.id + ' -> ' + e.message ).join('\n')}`, 'error');
        } else {
            notify(selectedIds.length + ' ' + translate('users.delete_all_ok') , 'success');
        }

        unselectAll(resource_name);
        refresh();

        handleClose();
        setLoading(false);
    };

    if (loading) return <MyLoading />;
    
    return (
        <>
            <Button label={translate('users.delete_all')} onClick={handleClickOpen} className="red_button" >
                <Delete />
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                    {(confirmTitle || translate('users.delete_all_confirm_title')).replace('%num_registers%',selectedIds.length)}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {confirmDescription || translate('users.delete_all_confirm_description')}
                        <br /><br/>{confirmAsk || translate('users.delete_all_confirm_description_ask')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} label={translate('ra.action.cancel')} />
                    <Button onClick={handleDelete} label={translate('users.delete_all')} className="red_button" >
                        <Delete />
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default BulkDeleteButton;
